import Vue from 'vue'
import Vuex from 'vuex'
import base from './module/base'
import returnOrder from '@/store/module/returnOrder'

Vue.use(Vuex)

const store = new Vuex.Store({
  modules: {
    base,
    returnOrder
  },
  getters: {
    returnOrderData: state => state.returnOrder.returnOrderData
  }
})

export default store
